/* eslint-disable react/jsx-no-undef */
import React, { useState } from "react";
import TextField from "@mui/material/TextField";

import Stack from "@mui/material/Stack";
import { useNavigate, useLocation } from "react-router-dom";
import { Controller, useForm } from "react-hook-form";
import SecondaryButton from "../../components/button/SecondaryButton";
import PrimaryButton from "../../components/button/PrimaryButton";
import TopBanner from '../../components/layout/TopBanner';
import { useDispatch, useSelector } from 'react-redux';
import TopLogo from '../../components/layout/TopLogo';
import { LocalizationProvider, MobileDatePicker } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import calendar from "../../assets/images/icon/calendar.svg";
import InputLabel from '@mui/material/InputLabel';
import { setRegisterMain } from "../../features/register/RegisterMainSlice";
import couponHead from "../../assets/images/coupon-head.png";
import globalStyle from "../../assets/styles/constants";
import Radio from "@mui/material/Radio";
import uploadBlue from "../../assets/images/icon/upload-blue.svg";
import { FormControl } from "@mui/material";
import { CreateCoupon } from "../../services/Coupon";
import dayjs from "dayjs";
import { Dialog } from "@mui/material";
import { faXmark } from "@fortawesome/free-solid-svg-icons";
import img from "../../assets/images/icon/img.svg";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import CustomPopup from '../../components/popup/CustomPopup';

export default function ShopAddCoupon() {


  const now = new Date();
  const store = useSelector((state) => state.shop)
  const { state } = useLocation();
  const dispatch = useDispatch()
  const navigate = useNavigate();
  const [image, setImage] = useState(state ? state.croppedImage : null);
  const [imageName, setImageName] = useState(state ? state.imageName : null);
  const [discountType, setDiscountType] = useState('Fix');
  const [openConfirmPopup, setOpenConfirmPopup] = React.useState(false);
  const [openCancelPopup, setOpenCancelPopup] = React.useState(false);
  const [openErrorImagePopup, setOpenErrorImagePopup] = React.useState(false);

  const [couponData, setCouponData] = useState(null);


  const { register, formState: { errors }, handleSubmit, control, watch, getValues } = useForm({
    defaultValues: {
      name: state ? state.name : '',
      amount: state ? state.amount : null,
      discount: state ? state.discount : null,
      minAmount: state ? state.minAmount : null,
      startDate: state ? state.startDate : null,
      expireDate: state ? state.expireDate : null,
      detail: state ? state.detail : '',
      conditions: state ? state.conditions : '',
      picture: ''
    }
  });

  function fnSetData(name, value) {
    const tmpObj = {};
    tmpObj[name] = value;
    dispatch(setRegisterMain(tmpObj));
  }

  React.useEffect(() => {
    const subscription = watch((value, { name, type }) => {
      if (name && type) {
        fnSetData(name, value[name]);
      }
    });
    return () => subscription.unsubscribe();
  }, [watch]);

  const onSubmit = async (data) => {
    if (state) {
      var base64data = null
      let blob = await fetch(state.croppedImage).then(r => r.blob());
      var reader = new FileReader();
      reader.readAsDataURL(blob);
      reader.onloadend = function () {
        base64data = reader.result.substring(reader.result.indexOf(",") + 1)
        setImage(base64data)
      }
    } else {
      setImage(null)
    }
    setOpenConfirmPopup(true)
    setCouponData(data)
  };

  React.useEffect(() => {
  }, []);


  async function postCreateCoupon() {
    try {

      let payload = {
        shopId: store['shopId'],
        name: couponData.name,
        amount: couponData.amount,
        discount: couponData.discount,
        discountType: discountType,
        minAmount: couponData.minAmount,
        startDate: dayjs(couponData.startDate).add(7, 'hours'),
        expireDate: dayjs(couponData.expireDate).add(7, 'hours'),
        detail: couponData.detail,
        conditions: couponData.conditions,
        picture: image
      }
      const { data } = await CreateCoupon({ data: payload });
      if (+data["resultCode"] === 20000) {
        navigate("/shop-coupon");
      } else {
        console.log('Error' + data["resultCode"])
      }
    } catch (error) {
      console.log("postCreateMember error", error);
    }
  }

  const handleImage = (event) => {
    const file = event.target.files[0];
    const reader = new FileReader();
    console.log(event.target.files[0].size)
    if (event.target.files[0].size > 5242880) {
      setOpenErrorImagePopup(true)
    } else {
      reader.onloadend = () => {
        setImageName((event.target.files[0].name))
        setImage(reader.result.substring(
          reader.result.indexOf(",") + 1
        ))
        navigate('/crop-image', {
          state: {
            image: reader.result,
            name: getValues('name'),
            amount: getValues('amount'),
            discount: getValues('discount'),
            minAmount: getValues('minAmount'),
            startDate: dayjs(getValues('startDate')).format('YYYY-MM-DD'),
            expireDate: dayjs(getValues('expireDate')).format('YYYY-MM-DD'),
            detail: getValues('detail'),
            conditions: getValues('conditions'),
            imageName: event.target.files[0].name
          }
        })
      };
      reader.readAsDataURL(file);
    }
  };

  function removeImage() {
    setImageName(null)
    setImage(null)
  };

  return (
    <>
      <form onSubmit={handleSubmit(onSubmit)} noValidate autoComplete="off">
        <TopLogo />
        <TopBanner type="memberPrivilage" />
        <div>
          <img src={couponHead} alt="logo" style={{ width: "100%", marginTop: "-45px" }} />
        </div>
        <div className="bg-white py-[10px] px-[20px]">
          <div style={{ padding: "0 10px" }}>
            <div className="flex gap-[10px] justify-center">
              <div className="primary-color title-size">ข้อมูลคูปอง</div>
              <div style={{ marginTop: "6px" }}>
                <p className="sub-title-size"> Coupon Information</p>
                <div className="blue-line" ></div>
              </div>
            </div>

            <div className="">
              <InputLabel className="text-header1 text-required text-left" htmlFor="txtMobileNumber">ชื่อคูปอง </InputLabel>
              <TextField
                id="txtMobileNumber"
                fullWidth
                required
                error={!!errors?.name}
                helperText={errors?.name?.message}
                placeholder="ชื่อคูปองของคุณ"
                {...register("name", { required: "กรุณากรอกชื่อคูปอง" })}
              // onChange={handleChangeEmail}
              />
            </div>

            <div className={errors.name ? "" : " mt-2"}>
              <InputLabel className="text-header1 text-required text-left" htmlFor="txtMobileNumber">จำนวนคูปอง </InputLabel>
              <TextField
                id="txtMobileNumber"
                fullWidth
                type="number"
                required
                error={!!errors?.amount}
                helperText={errors?.amount?.message}
                placeholder="จำนวนคูปองที่ต้องการ"
                {...register("amount", { required: "กรุณากรอกจำนวนคูปองที่ต้องการ" })}
              // onChange={handleChangeEmail}
              />
            </div>

            <div className={errors.amount ? "" : " mt-2"}>
              <InputLabel className="text-header1 text-required text-left" htmlFor="txtMobileNumber">ประเภทส่วนลด </InputLabel>
              <div className="flex gap-[5px] justify-start">
                <div className="flex gap-[5px] justify-start">
                  <Radio
                    checked={discountType === 'Fix'}
                    onChange={() => setDiscountType('Fix')}
                    value='Fix'
                    name="radio-buttons"
                    inputProps={{ "aria-label": "true" }}
                    sx={globalStyle.radioStyle}
                  />
                  <InputLabel className="text-left mt-[4px]">จำนวน (฿)</InputLabel>
                </div>
                <div className="flex gap-[5px] justify-start">
                  <Radio
                    checked={discountType === 'Percent'}
                    onChange={() => {
                      setDiscountType('Percent')
                    }
                    }
                    value='Percent'
                    name="radio-buttons"
                    inputProps={{ "aria-label": "false" }}
                    sx={globalStyle.radioStyle}
                  />
                  <InputLabel className="text-left mt-[4px]">เปอร์เซ็นต์ (%)</InputLabel>
                </div>
              </div>
            </div>

            <div className="mt-2">
              <TextField
                id="txtMobileNumber"
                fullWidth
                type="number"
                required
                error={!!errors?.discount}
                helperText={errors?.discount?.message}
                placeholder="กรุณากรอกส่วนลด"
                {...register("discount", { required: "กรุณากรอกส่วนลด" })}
              // onChange={handleChangeEmail}
              />
            </div>

            <div className={errors.discount ? "" : " mt-2"}>
              <InputLabel className="text-header1 text-required text-left" htmlFor="txtMobileNumber">ยอดขั้นต่ำ </InputLabel>
              <TextField
                id="txtMobileNumber"
                fullWidth
                type="number"
                required
                error={!!errors?.minAmount}
                helperText={errors?.minAmount?.message}
                placeholder="กรุณากรอกจำนวนขั้นต่ำ"
                {...register("minAmount", { required: "กรุณากรอกจำนวนขั้นต่ำ" })}
              // onChange={handleChangeEmail}
              />
            </div>

            <div className={errors.minAmount ? "flex gap-[10px] justify-between" : "flex gap-[10px] justify-between mt-2"}>
              <div className={'relative'}>
                <InputLabel required={true} className="text-header1 text-required text-left" htmlFor="txtEmail">เวลาเริ่มต้น </InputLabel>
                <Controller
                  name="startDate"
                  control={control}
                  rules={{
                    required: "กรุณาเลือกเวลาเริ่มต้นคูปอง",
                  }}
                  render={({ field }) => (
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <MobileDatePicker
                        {...field}
                        className="w-full"
                        inputFormat="DD/MM/YYYY"
                        minDate={now}
                        name="startDate"
                        onChange={(date) => field.onChange(date)}
                        selected={field.value}
                        renderInput={(params) => (
                          <TextField
                            name="startDate"
                            {...params}
                            error={!!errors?.startDate}
                            helperText={errors?.startDate?.message}
                            placeholder="เวลาเริ่มต้นคูปอง"
                          />
                        )}
                      />
                      <img
                        className={
                          `absolute right-[10px] bottom-[15px] w-[18px] pointer-events-none ` +
                          (!!errors?.startDate
                            ? "bottom-[42px]"
                            : null)
                        }
                        src={calendar}
                        alt=""
                      />
                    </LocalizationProvider>
                  )}
                />
              </div>
              <div className={'relative'}>
                <InputLabel required={true} className="text-header1 text-required text-left" htmlFor="txtEmail">เวลาสิ้นสุด </InputLabel>
                <Controller
                  name="expireDate"
                  control={control}
                  rules={{
                    required: "กรุณาเลือกวัน/เดือน/ปีที่เกิด",
                  }}
                  render={({ field }) => (
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <MobileDatePicker
                        {...field}
                        className="w-full"
                        inputFormat="DD/MM/YYYY"
                        minDate={now}
                        name="expireDate"
                        onChange={(date) => field.onChange(date)}
                        selected={field.value}
                        renderInput={(params) => (
                          <TextField
                            name="expireDate"
                            {...params}
                            error={!!errors?.expireDate}
                            helperText={errors?.expireDate?.message}
                            placeholder="เวลาสิ้นสุดคูปอง"
                          />
                        )}
                      />
                      <img
                        className={
                          `absolute right-[10px] bottom-[15px] w-[18px] pointer-events-none ` +
                          (!!errors?.expireDate
                            ? "bottom-[42px]"
                            : null)
                        }
                        src={calendar}
                        alt=""
                      />
                    </LocalizationProvider>
                  )}
                />
              </div>
            </div>

            <div className={(errors.startDate || errors.expireDate) ? "" : " mt-2"}>
              <InputLabel className="text-header1 text-required text-left" htmlFor="txtMobileNumber">รายละเอียด </InputLabel>
              <TextField
                id="txtMobileNumber"
                fullWidth
                multiline
                rows={3}
                required
                error={!!errors?.detail}
                helperText={errors?.detail?.message}
                placeholder="กรุณากรอกรายละเอียดของคูปอง"
                {...register("detail", { required: "กรุณากรอกรายละเอียดของคูปอง" })}
              // onChange={handleChangeEmail}
              />
            </div>

            <div className={errors.detail ? "" : " mt-2"}>
              <InputLabel className="text-header1 text-required text-left" htmlFor="txtMobileNumber">เงื่อนไขคูปอง </InputLabel>
              <TextField
                id="txtMobileNumber"
                fullWidth
                multiline
                rows={3}
                required
                error={!!errors?.conditions}
                helperText={errors?.conditions?.message}
                placeholder="กรุณากรอกเงื่อนไขของคูปอง"
                {...register("conditions", { required: "กรุณากรอกเงื่อนไขของคูปอง" })}
              // onChange={handleChangeEmail}
              />
            </div>

            <div className={errors.detail ? "h-[1px] bg-lightGray3 w-full mb-2" : "h-[1px] bg-lightGray3 w-full mt-2 mb-2"}></div>

            {image ? (
              <div className="px-[20px] mb-[10px] w-full h-[48px] relative flex justify-center items-center gap-[5px] rounded-full border-[1px] border-lightBlue">
                <img className="w-[17px]" src={img} alt="" />
                <p className="short-text text-lightblue text-[24px]"> {imageName}</p>
                <div
                  onClick={() => {
                    removeImage();
                  }}
                  className="cursor-pointer flex gap-[5px] items-center right-[20px] top-[0px] py-[1px]"
                >
                  <FontAwesomeIcon
                    icon={faXmark}
                    className="w-[12px] text-red"
                  />
                </div>
              </div>
            ) : (

              <FormControl fullWidth>
                <div className="mb-[10px] w-full h-[48px] relative flex justify-center items-center gap-[5px] rounded-full bg-white border-[1px] border-blue">
                  <img className="w-[13px]" src={uploadBlue} alt="" />
                  <p className="text-blue text-[20px]">อัปโหลดไฟล์ภาพประกอบ</p>
                  <input
                    className="opacity-0 absolute left-0 top-0 bottom-0 right-0"
                    name="urlPicture"
                    type="file"
                    accept=".jpg, .jpeg, .png"
                    onChange={(event) => handleImage(event)}
                  />
                </div>
              </FormControl>
            )}
            <div className="mt-[-5px]" style={{ fontSize: '0.8571428571428571rem', color: '#8F8F8F' }}>* รูปต้องมีขนาดไม่เกิน 5 MB</div>

            {/* {image &&
              <img className="w-[100px]" src={image} alt="" />
            } */}

          </div>
        </div>

        <div className="bg-white mt-[20px] h-[100px] pt-[25px]">
          <Stack
            spacing={2}
            direction="row"
            alignItems="center"
            justifyContent="center"
          >
            <SecondaryButton variant="outlined" className="w-[40%]" onClick={() => setOpenCancelPopup(true)}>
              ยกเลิก
            </SecondaryButton>
            <PrimaryButton variant="contained" className="w-[40%]" type="submit">
              ยืนยัน
            </PrimaryButton>
          </Stack>
        </div>
      </form>

      <Dialog open={openConfirmPopup} fullWidth={true} maxWidth="xl">
        <div className="py-[24px] px-[23px] rounded-[4px]">
          <p className="text-[24px] font-bold text-center text-blue">สร้างคูปอง</p>
          <p className="text-gray text-[18px] text-center whitespace-pre-line leading-[120%]">คุณกำลังสร้างคูปอง </p>
          <p className="text-red text-[18px] text-center whitespace-pre-line leading-[120%]"> โดยรายละเอียดไม่สามารถแก้ไขได้</p>
          <p className="text-gray text-[18px] text-center whitespace-pre-line leading-[120%]"> คุณยืนยันว่าได้ระบุรายละเอียดถูกต้องแล้วใช่หรือไม่</p>


          <div className="flex itesm-center gap-[13px] justify-center mt-[24px]">

            <SecondaryButton
              variant="outlined"
              className="w-full"
              onClick={() => setOpenConfirmPopup(false)}
            >
              ยกเลิก
            </SecondaryButton>
            <PrimaryButton
              onClick={() => postCreateCoupon()}
              variant="outlined"
              className="w-full"
            >
              ยืนยัน
            </PrimaryButton>

          </div>

        </div >
      </Dialog >

      <Dialog open={openCancelPopup} fullWidth={true} maxWidth="xl">
        <div className="py-[24px] px-[23px] rounded-[4px]">
          <p className="text-[24px] font-bold text-center text-blue">ยกเลิกสร้างคูปอง</p>
          <p className="text-gray text-[18px] text-center whitespace-pre-line leading-[120%]">คุณต้องการยกเลิกการสร้างคูปอง</p>
          <p className="text-gray text-[18px] text-center whitespace-pre-line leading-[120%]">หากมั่นใจแล้ว กรุณากด ยืนยัน เพื่อดำเนินการต่อ </p>

          <div className="flex itesm-center gap-[13px] justify-center mt-[24px]">

            <SecondaryButton
              variant="outlined"
              className="w-full"
              onClick={() => setOpenCancelPopup(false)}
            >
              ยกเลิก
            </SecondaryButton>
            <PrimaryButton
              onClick={() => {
                navigate('/shop-coupon')
                setOpenCancelPopup(false);
              }}
              variant="outlined"
              className="w-full"
            >
              ยืนยัน
            </PrimaryButton>

          </div>

        </div >
      </Dialog >

      <CustomPopup
        title='รูปต้องมีขนาดไม่เกิน 5 MB'
        desc='กรุณาลองใหม่อีกครั้ง'
        cancelText="ปิด"
        cancelFunction={() => {
          setOpenErrorImagePopup(false);
        }}
        open={openErrorImagePopup}
      />
    </>
  );
}
